import useUpdateApolloOnChain from './common/apollo/hooks/useUpdateApolloOnChain'
import MainLayout from './common/components/MainLayout'
import useIframeLocationChange from './common/hooks/useIframeLocalionChange'
import useHandleSwitchChain from './common/hooks/web3/useHandleSwitchChain'
import { useInitialLoading } from './common/hooks/web3/useInitialLoading'

const App = () => {
  useUpdateApolloOnChain()
  useHandleSwitchChain()
  useIframeLocationChange()
  useInitialLoading()

  return <MainLayout />
}

export default App
